import React from 'react';
const Check = ({ ...r }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...r}>
            <path
                fill="#272727"
                fillRule="evenodd"
                d="M10 15.172l8.485-8.486A1 1 0 1119.9 8.1l-9.193 9.193a1 1 0 01-1.414 0l-4.95-4.95a1 1 0 111.414-1.414L10 15.172z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}

export default Check;